import React from "react";
import "./index.css";
import Container from "../../../Components/General/Container";
// Map art and pin icon live on the landing-page CDN (Figma 11883:2805).
const MAP_IMG = "https://images.nowpurchase.com/landing/";
const indiaMap = `${MAP_IMG}20260929095731_india-map.png`;
const cityPin = `${MAP_IMG}20260929095732_city-pin.svg`;

// Pin coordinates come straight from Figma node 11883:2805 — each pin's offset
// inside the 787 x 856 map frame, expressed as a percentage so the map can
// scale freely.
const MAP_W = 787;
const MAP_H = 856;

const pins = [
  { id: "north", x: 217.4, y: 228.4 },
  { id: "west-upper", x: 136, y: 424 },
  { id: "central", x: 431, y: 396 },
  { id: "east-upper", x: 497, y: 389 },
  { id: "east-lower", x: 497, y: 428 },
  { id: "west-lower", x: 227, y: 521 },
  { id: "south-west", x: 184, y: 553 },
  { id: "south", x: 273, y: 712 },
];

function GlobalPresence() {
  return (
    <div className="presenceSectionWrap animated-section section">
      <Container>
        <div className="presenceRow">
          <div className="presenceCopy aosAnim">
            <h2 className="presenceTitle">
              Multiple Cities, One Shared Purpose
            </h2>
            <p>
              Across every city we operate in, our teams work as one unified
              force connected, collaborative, and driven by a shared mission.
              Every location is a vital touchpoint in a larger network, where
              ideas flow seamlessly across borders and each office contributes
              to the strength of the whole. No matter where you are, you're
              never working in isolation you're part of a purpose that spans the
              entire organization, with every team pulling in the same direction
              to create impact at scale.
            </p>
          </div>

          <div className="presenceMap">
            <img
              className="presenceMapImg"
              loading="lazy"
              src={indiaMap}
              alt="NowPurchase locations across India"
            />
            {pins.map((pin) => (
              <span
                key={pin.id}
                className="presencePin"
                style={{
                  left: `${(pin.x / MAP_W) * 100}%`,
                  top: `${(pin.y / MAP_H) * 100}%`,
                }}
              >
                <img src={cityPin} alt="" aria-hidden="true" />
              </span>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default GlobalPresence;
